/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useMemo } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { List } from 'react-virtualized/dist/commonjs';

import { Text, TextInput, Icon } from '../../uiold';
import { themeColors } from '../../uiold/Constants';

import { useSimpleViewDispatch, useSimpleViewState } from './Context';
import TagItem from '../../VendorPlacement/TagItem';
import { getRemainingBalance } from '../../../support/shared/calculatePrice';

import { ListRowProps } from 'react-virtualized';
import { VendorSummaryWithMarkets } from '../../../types/shared/Vendor';

type ItemProps = {
  isActive: boolean;
  vendor: VendorSummaryWithMarkets;
  style: StyleSet;
};

function ModalVendorListItem(props: ItemProps) {
  let { isActive, vendor, style } = props;
  let { tags } = useSimpleViewState();
  let dispatch = useSimpleViewDispatch();

  let tagList = useMemo(() => {
    let vendorTags = new Set(vendor.tags);
    return tags // Only include the tag owned by the vendor.
      .filter((tag) => vendorTags.has(tag.id))
      .map((tag) => <TagItem key={tag.id} tag={tag} />);
  }, [tags, vendor]);
  let amountOwed = vendor.billing ? getRemainingBalance(vendor.billing) : null;

  return (
    <TouchableOpacity
      activeOpacity={0.6}
      onPress={() => dispatch({ type: 'ON_VENDOR_CLICK', vendor })} // Style from the prop should not be the last since it pass a hardcoded height = totalHeight,
      // but we want height = totalHeight - margin.
      style={[style, styles.vendorItem, isActive && styles.activeVendorItem]}
    >
      <Text style={styles.vendorName}>{vendor.name}</Text>
      <View style={styles.flexRow}>
        <View style={styles.tagContainer}>{tagList}</View>
        {amountOwed && amountOwed > 0 ? (
          <Icon
            color={themeColors.red}
            name="xMark"
            size="XS"
            style={{ marginLeft: 3 }}
          />
        ) : (
          <Icon color={themeColors.greenButtonHovered} name="check" size="S" />
        )}
      </View>
    </TouchableOpacity>
  );
}

/**
 * List of vendor displayed inside the placement modal when using the simple view.
 */
function ModalVendorList(props: { width: number; height: number }) {
  let { width, height } = props;
  let { activeVendor, market, vendors } = useSimpleViewState();
  let [filterKeyword, setFilterKeyword] = useState('');

  let keyword = filterKeyword.toLowerCase();
  let filteredVendors = vendors.filter((vendor) => {
    let markets = vendor.markets || {};
    let isVendorActive = markets[market.id];

    if (!isVendorActive) {
      return false;
    }

    let isKeywordFound =
      filterKeyword === ''
        ? true
        : (vendor.name || '').toLowerCase().includes(keyword);

    return isKeywordFound;
  });

  let rowRenderer = ({ key, index, style }: ListRowProps) => {
    let vendor = filteredVendors.getByIndex(index);
    if (!vendor) {
      return null;
    }

    return (
      <ModalVendorListItem
        key={key}
        vendor={vendor}
        isActive={!!activeVendor && vendor.id === activeVendor.id}
        style={style as any}
      />
    );
  };
  let textInputHeight = 34;
  let textInputMargin = 10;
  let remainingHeight = height - textInputHeight - textInputMargin;
  return (
    <>
      <TextInput
        style={{ marginBottom: textInputMargin }}
        value={filterKeyword}
        placeholder="Search Vendors"
        onChangeText={setFilterKeyword}
      />
      <List
        width={width}
        height={remainingHeight}
        rowCount={filteredVendors.length}
        rowHeight={ModalVendorListItem.totalHeight}
        rowRenderer={rowRenderer}
      />
    </>
  );
}

ModalVendorListItem.height = 60;
ModalVendorListItem.marginBottom = 4;
ModalVendorListItem.totalHeight =
  ModalVendorListItem.height + ModalVendorListItem.marginBottom;

let styles = StyleSheet.create({
  flexRow: { flexDirection: 'row' },
  vendorItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: ModalVendorListItem.height,
    marginBottom: ModalVendorListItem.marginBottom,
    paddingHorizontal: 20,
    backgroundColor: themeColors.white,
    borderColor: themeColors.grey,
    borderRadius: 4,
    borderWidth: StyleSheet.hairlineWidth,
    overflowY: 'hidden',
  } as any,
  activeVendorItem: {
    backgroundColor: themeColors.withOpacity.blue8,
    borderColor: themeColors.withOpacity.blue50,
    borderWidth: StyleSheet.hairlineWidth * 2,
  },
  vendorName: {
    textOverflow: 'ellipsis',
  } as any,
  tagContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginHorizontal: 20,
    overflow: 'visible',
  },
});

export default ModalVendorList;
